import { useValueChangeEffect } from '../useValueChangeEffect';

import { usePath } from './usePath';

export function useRouteChange(
	callback: (previousPath: string, currentPath: string) => void,
) {
	const { pathname } = usePath();

	useValueChangeEffect(pathname, callback);
}
